import { useState, useEffect } from 'react';

export const useFavorites = () => {
  const [favorites, setFavorites] = useState([]);

  // Charger les favoris depuis localStorage au démarrage
  useEffect(() => {
    try {
      const savedFavorites = localStorage.getItem('soundnest-favorites');
      if (savedFavorites) {
        const parsedFavorites = JSON.parse(savedFavorites);
        setFavorites(Array.isArray(parsedFavorites) ? parsedFavorites : []);
      }
    } catch (error) {
      console.error('Erreur lors du chargement des favoris:', error);
      setFavorites([]);
    }
  }, []);

  // Sauvegarder les favoris dans localStorage à chaque changement
  useEffect(() => {
    try {
      localStorage.setItem('soundnest-favorites', JSON.stringify(favorites));
    } catch (error) {
      console.error('Erreur lors de la sauvegarde des favoris:', error);
    }
  }, [favorites]);

  const addToFavorites = (sound) => {
    setFavorites(prev => {
      // Vérifier si le son n'est pas déjà dans les favoris
      if (prev.some(fav => fav.id === sound.id)) {
        return prev;
      }
      return [...prev, { ...sound, addedAt: new Date().toISOString() }];
    });
  };

  const removeFromFavorites = (soundId) => {
    setFavorites(prev => prev.filter(fav => fav.id !== soundId));
  };

  const isFavorite = (soundId) => {
    return favorites.some(fav => fav.id === soundId);
  };

  const clearFavorites = () => {
    setFavorites([]);
  };

  return {
    favorites,
    addToFavorites,
    removeFromFavorites,
    isFavorite,
    clearFavorites
  };
};
